import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, Sorting } from 'devextreme-react/data-grid';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Confirm, Transition } from 'semantic-ui-react';
import { emailApi } from '../../api/emailApi';
import { DangerButton, DefaultButton, PrimaryButton } from '../../components/editor/button';
import { useCommonContext } from '../../contexts/common';
import { showNotify } from "../../helpers/toast";
import DotGuiDetailModal from "./detail_modal";
import { PheDuyetModal } from './phe-duyet';
import { EmailPageSummary } from './summary-info';

const iniState = {
    emails: [],
    selected_email: {},
};
const actionTypes = {
    SET_EMAILS: 'SET_EMAILS',
    SET_SELECTED_EMAIL: 'SET_SELECTED_EMAIL',
};
const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.SET_EMAILS:
            return {
                ...state,
                emails: action.payload,
            };
        case actionTypes.SET_SELECTED_EMAIL:
            return {
                ...state,
                selected_email: action.payload,
            };
        default:
            return state;
    }
}
const EmailPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { dm_coso_id } = useSelector(x => x.coSo);
    const history = useHistory();
    const [filterStatusId, setFilterStatusId] = useState(0);
    const [state, dispatch] = useReducer(reducer, iniState);
    const [isShowDetailModal, setIsShowDetailModal] = useState(false);
    const [isShowPheDuyetModal, setIsShowPheDuyetModal] = useState(false);
    const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);
    const [isShowSendEmail, setIsShowSendEmail] = useState(false);
    const { user } = useSelector((x) => x.auth);

    const { canAccessTo, translate } = useCommonContext();
    const grid = useRef(null);

    useEffect(() => {
        if (isLoading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [isLoading]);
    useEffect(() => {
        hanleLoadEmail();
    }, [dm_coso_id])
    const dataSource = useMemo(() => {
        return state.emails.filter(x => (x.dm_trangthai_email_id == filterStatusId || filterStatusId == 0))
    }, [filterStatusId, state.emails])
    const hanleLoadEmail = async () => {
        setIsLoading(true);
        const res = await emailApi.SelectByCoSo(dm_coso_id);
        if (res.is_success) {
            setIsLoading(false);
            dispatch({ type: actionTypes.SET_EMAILS, payload: res.data });
        }
    }
    const btnEdit_click = (data) => {
        dispatch({ type: actionTypes.SET_SELECTED_EMAIL, payload: data });
        setIsShowDetailModal(true);
    };

    const btnDelete_click = (data) => {
        dispatch({ type: actionTypes.SET_SELECTED_EMAIL, payload: data });
        setIsShowConfirmDelete(true);
    };
    const confirmDelete = async () => {
        const res = await emailApi.Delete(state.selected_email.id);
        if (res.is_success) {
            hanleLoadEmail();
            setIsShowConfirmDelete(false);
        } else {
            showNotify({ text: res.message, type: "error" });
        }
    };

    const btnSendEmail_click = (data) => {
        dispatch({ type: actionTypes.SET_SELECTED_EMAIL, payload: data });
        setIsShowSendEmail(true);
    };
    const confirmSendEmail = async () => {
        const res = await emailApi.SavePheDuyet(state.selected_email.id);
        if (res.is_success) {
            hanleLoadEmail();
            setIsShowSendEmail(false);
        } else {
            showNotify({ text: res.message, type: "error" });
        }
    };
    const cellRender = (data) => {
        const createNew = data.data.dm_trangthai_email_id == 1;
        const approved = data.data.dm_trangthai_email_id == 3;
        const filteredRoles = user.roles
            .map(role => {
                if (role.id === 1 && role.is_active) {
                    return role;
                }
            })
            .filter(role => role !== undefined);
        return (
            <div>
                {(createNew || (filteredRoles)) &&  (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            btnEdit_click(data.data);
                        }}
                    >
                        <i aria-hidden="true" className="icon edit"></i>{' '}
                    </span>
                )}
                {(createNew || (filteredRoles)) && (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            btnDelete_click(data.data);
                        }}
                    >
                        <i aria-hidden="true" className="icon trash"></i>{' '}
                    </span>
                )}
                {approved && (
                    <span
                        style={{ cursor: 'pointer', color: 'green' }}
                        onClick={() => {
                            btnSendEmail_click(data.data);
                        }}
                    >
                        <i aria-hidden="true" className="icon send"></i>{' '}
                    </span>
                )}
            </div>
        );
    };
    return (
        <div>
            <React.Fragment>
                <Transition
                    animation="scale"
                    visible={true}
                    duration={200}
                    transitionOnMount={true}
                >
                    <div>
                        <div className="row">
                            <div className="col-md-12 padding-top-1rem padding-left-2rem">
                                <Toolbar className="bg-background">
                                    <Item
                                        location="before"
                                        render={() => {
                                            return <h3>{translate('Email đã tạo')}</h3>;
                                        }}
                                    />
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <PrimaryButton
                                                    icon={"fas fa-check"}
                                                    text={"Phê duyệt"}
                                                    onClick={() => {
                                                        setIsShowPheDuyetModal(true)
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <PrimaryButton
                                                    icon={"fas fa-plus"}
                                                    text={"Tạo đợt gửi"}
                                                    onClick={() => {
                                                        setIsShowDetailModal(true)
                                                        dispatch({
                                                            type: actionTypes.SET_SELECTED_EMAIL,
                                                            payload: { id: 0 },
                                                        });
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <DefaultButton
                                                    text={'Tải lại dữ liệu'}
                                                    icon={'fas fa-sync-alt'}
                                                    onClick={() => hanleLoadEmail()}
                                                />
                                            );
                                        }}
                                    />
                                    {/* <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <PrimaryButton
                                                    text={"Tạo email mới"}
                                                    onClick={() => {
                                                        history.push("../../email-template")
                                                    }}
                                                />
                                            );
                                        }}
                                    /> */}

                                </Toolbar>
                            </div>
                            <div className='col-md-12'>
                                <EmailPageSummary onSelectionChanged={setFilterStatusId} emails={state.emails} />
                            </div>
                            <div className="col-md-12 padding-top-5">
                                <DataGrid
                                    ref={grid}
                                    keyExpr="id"
                                    dataSource={dataSource}
                                    columnHidingEnabled={false}
                                    columnAutoWidth={false}
                                    showBorders={true}
                                    showColumnLines={true}
                                    showRowLines={true}
                                    rowAlternationEnabled={true}
                                    allowColumnResizing={true}
                                    columnResizingMode={'nextColumn'}
                                    hoverStateEnabled={true}
                                    focusedRowEnabled={false}
                                    height={window.innerHeight - 150}
                                    className={'table-noborder-left'}
                                    wordWrapEnabled={false}
                                // onSelectionChanged={onLopSelectionChanged}
                                >
                                    <Column
                                        key={0}
                                        cellRender={cellRender}
                                        caption={"Thao tác"}
                                        minWidth={70}
                                        width={'auto'}
                                    ></Column>,

                                    <Column minWidth={350} dataField={"subject"} caption={"Subject"} cellRender={(cell) => {
                                        return <Link to={`/send-email-detail/${cell.data.ts_email_template_id}_${cell.data.id}`}>
                                            {cell.data.subject}
                                        </Link>
                                    }} />
                                    <Column minWidth={170} dataField={"nguoi_tao"} caption={"Người tạo"} />
                                    <Column minWidth={150} dataField={"ngay_tao"} caption={"Ngày tạo"} format={"dd/MM/yyyy"} dataType={"date"} />
                                    <Column minWidth={170} dataField={"nguoi_phe_duyet"} caption={"Người phê duyệt"} />
                                    <Column minWidth={150} dataField={"ngay_phe_duyet"} caption={"Ngày phê duyệt"} format={"dd/MM/yyyy"} dataType={"date"} />
                                    <Column minWidth={150} dataField={"trang_thai_phe_duyet"} caption={"Trạng thái"} />
                                    <Column minWidth={140} dataField={"total_user"} caption={"Total User"} />
                                    <Column minWidth={140} dataField={"total_success"} caption={"Total send success"} />
                                    <Column minWidth={140} dataField={"total_fail"} caption={"Total send fail"} />
                                    {/* <Selection mode="multiple" selectAllMode="allPages"></Selection> */}
                                    <Sorting mode="multiple" />
                                    <Paging defaultPageSize={30} />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={true} />
                                    <HeaderFilter visible={true} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 20, 50, 200, 500]}
                                        infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                                            'dòng'
                                        )})`}
                                        showInfo={true}
                                    />
                                </DataGrid>
                            </div>
                            {isShowDetailModal &&
                                <DotGuiDetailModal
                                    id={state.selected_email.id}
                                    username ={user.username}
                                    onCancel={() => { setIsShowDetailModal(false) }}
                                    onSuccess={() => { setIsShowDetailModal(false); hanleLoadEmail(); }}
                                />
                            }
                            {isShowPheDuyetModal &&
                                <PheDuyetModal
                                    dataSource={state.emails}
                                    onCancel={() => { setIsShowPheDuyetModal(false); hanleLoadEmail(); }}
                                    onSuccess={() => { isShowPheDuyetModal(false); hanleLoadEmail(); }}
                                />
                            }
                        </div>
                    </div>
                </Transition>
                <Confirm
                    open={isShowConfirmDelete}
                    dimmer={'blurring'}
                    header={translate('Lưu ý')}
                    content={translate('Bạn có chắc chắn muốn xóa dữ liệu ?')}
                    size="mini"
                    cancelButton={() => {
                        return (
                            <DefaultButton text={"Đóng"} onClick={() => {
                                setIsShowConfirmDelete(false);
                            }} />
                        );
                    }}
                    confirmButton={() => {
                        return (
                            <DangerButton text={"Xóa email"} onClick={confirmDelete} />
                        );
                    }}
                />
                <Confirm
                    open={isShowSendEmail}
                    dimmer={'blurring'}
                    header={translate('Lưu ý')}
                    content={translate('Bạn có chắc chắn muốn gửi email này ?')}
                    size="mini"
                    cancelButton={() => {
                        return (
                            <DefaultButton text={"Đóng"} onClick={() => {
                                setIsShowSendEmail(false);
                            }} />
                        );
                    }}
                    confirmButton={() => {
                        return (
                            <PrimaryButton text={"Gửi email"} onClick={confirmSendEmail} />
                        );
                    }}
                />
            </React.Fragment>
        </div>
    );
};

export default EmailPage;